<template>
	<div class="flex flex-col justify-center items-center pt-20 md:pt-32">
		<EmptyStateSVG />
		<p class="text-zt-primary-200 text-zt-lg text-base leading-5 pt-4 font-normal text-center">{{
			$t("message.homeComponent.noForm") }}</p>
	</div>
</template>

<script>
import EmptyStateSVG from "./EmptyStateSVG";

export default {
	name: "EmptyState",
	components: {
		EmptyStateSVG
	}
};
</script>

<style scoped></style>
